var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.708,
    height: 10.569,
    viewBox: "0 0 14.708 10.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5100",
    "data-name": "Group 5100",
    transform: "translate(1.393 0.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7310",
    "data-name": "Path 7310",
    d: "M1143.362,454.4h-12.591",
    transform: "translate(-1130.046 -449.807)",
    fill: "none",
    stroke: "#2c5ba7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7311",
    "data-name": "Path 7311",
    d: "M1142.083,451.13l-4.45,4.588,4.45,4.589",
    transform: "translate(-1137.633 -451.13)",
    fill: "none",
    stroke: "#2c5ba7",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLeftArrow);
export default __webpack_public_path__ + "static/media/blue_left_arrow.32862c1317418a44a279991857172391.svg";
export { ForwardRef as ReactComponent };